import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { PUBLIC } from 'router/constants/routes';

import { FORGOT_PASSWORD } from 'store/user/actionTypes';
import { createProcessingSelector } from 'store/loading/selectors';

import { sendAnalyticResetPassLoginButtonClick, sendAnalyticResetPassResendPasswordClick } from 'services/analytics';

import { useSelector } from 'react-redux';

import OutlinedButton from 'components/OutlinedButton';
import { Image, Text } from 'components/library';
import ContactUsLink from 'components/ContactUsLink';

import * as S from '../styled';

import checkMailBoxIcon from 'assets/img/checkMailbox.svg';

const CheckMailBox = ({ email, onResendPassword }: { email: string; onResendPassword: () => void }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const isLoading: boolean = useSelector(createProcessingSelector([FORGOT_PASSWORD]));

    const handleLogin = () => {
        sendAnalyticResetPassLoginButtonClick();

        navigate(PUBLIC.LOGIN.path);
    };

    const handleResend = () => {
        sendAnalyticResetPassResendPasswordClick();

        onResendPassword();
    };

    return (
        <S.CheckMailBox $paddingX={16}>
            <Image maxWidth={48} center alt="checkMailBoxIcon" src={checkMailBoxIcon} mb={24} />
            <Text type="h5" bold center mb={12}>
                {t('forgotPassword.checkMailBox')}
            </Text>
            <Text center>{t('forgotPassword.passwordWasSent')}</Text>
            {email && (
                <Text bold center mb={32}>
                    {email}
                </Text>
            )}
            <S.LogInButton mb={12} onClick={handleLogin} dataLocator="resetPasswordLoginBtn">
                {t('basics.login')}
            </S.LogInButton>
            <OutlinedButton onClick={handleResend} mb={28} isLoading={isLoading} dataLocator="resendPasswordBtn">
                {t('forgotPassword.resendPassword')}
            </OutlinedButton>
            <ContactUsLink />
        </S.CheckMailBox>
    );
};

export default CheckMailBox;
